import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { getUrl } from '../_shared/utils';
import { DialogService } from '../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhotoService } from '../_services/photo.service';
import { ClipboardService } from 'ngx-clipboard';
import { ImageUploadModalComponent } from './image-upload-modal.component';
import { S3Service } from '../_services/s3.service';


@Component({
    selector: 'app-image-upload-management',
    templateUrl: './image-upload-management.component.html',
    styleUrls: ['./image-upload-management.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class ImageUploadManagementComponent implements OnInit {

    baseUrl = getUrl();

    images = [];
    loading = false;
    copied = {};
    displayInactive = false;

    display = [];
    searchText = '';

    private bsModalRef: BsModalRef;

    constructor(
        private photoService: PhotoService,
        private clipboardService: ClipboardService, 
        private modalService: BsModalService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private spinner: NgxSpinnerService) { }

    ngOnInit() {
        this.loadImages();
    }

    filterImages() {
        let temp = this.images;

        if (this.searchText != null && this.searchText !== '') {
            temp = temp.filter(
                p => (p.name != null ? p.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false) 
                || (p.path != null ? p.path.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false));
        }
        this.display = temp;
    }

    loadImages() {
        this.copied = {};
        this.loading = true;
        this.spinner.show();
        this.photoService.getAdminImages().subscribe(
            data => {
                this.images = data;
                this.display = data;
                this.loading = false;
                this.spinner.hide();
            },
            error => {
                this.displayErrorMessage();
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    copy(url: string, rowIndex: number) {
        this.copied = {};
        this.copied[rowIndex + '-url'] = true;
        this.clipboardService.copyFromContent(url);
    }

    delete(bucketName: string, path: string, name: string) {
        this.loading = true;
        this.spinner.show();
        this.photoService.deleteAdminImage(bucketName, path + '/' + name).subscribe(
            () => {
                this.loadImages();
            },
            error => {
                this.displayErrorMessage();
                this.loading = false;
                this.spinner.hide();
            }
        );
    }


    public openImageUpload() {
        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: false
        };

        this.bsModalRef = this.modalService
            .show(
                ImageUploadModalComponent,
                Object.assign({}, modalConfig, { class: 'modal-sm' }));

            this.bsModalRef.content.hasError.subscribe(
                value => {
                    if (value) {
                        this.displayErrorMessage();
                    } else {
                        this.loadImages();
                    }
                });
    }

    private displayErrorMessage() {
        this.dialogService.alert(
          'Error',
          'Unable to get images from S3',
        this.viewRef);
      }

}
